import React, { Component } from 'react'
import { ResponsiveContainer, Line, LineChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend } from 'recharts'

import Loader from '../Loader'


class BaselinePowerSOC extends Component {

    render() {
        const p_fcr_ems_max = this.props.unit === 'kW' ? this.props.site.battery.servicesConfig.FCR.p_fcr_ems_max * 1000 : this.props.site.battery.servicesConfig.FCR.p_fcr_ems_max

        return (
            <div className="card border-0 mb-4 chart-card">
                <div className="card-body">
                    <h4 className="card-title">Baseline Power for SOC management
                        <div className="float-md-right">
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="checkbox" name="yaxis" id="yaxis_BaselinePowerSOC" onChange={e => this.props.toggleDynamicYAxis(e, 'BaselinePowerSOC')} />
                                <label className="form-check-label" htmlFor="yaxis_BaselinePowerSOC">Dynamic Y Axis</label>
                            </div>
                        </div>
                    </h4>
                    {
                        this.props.loadingFrequencyData ? <Loader className="height-400" /> :
                            !this.props.frequencyData || !this.props.frequencyData.length ?
                                <div className="height-400 d-flex align-items-center justify-content-center text-muted">Data not available</div> :
                            <ResponsiveContainer width="100%" height={400}>
                                <LineChart data={this.props.frequencyData} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
                                    <CartesianGrid stroke="#ddd" strokeDasharray="0.2 0.2" />
                                    <XAxis dataKey="time" tickFormatter={this.props.tickFormatterX} minTickGap={50} />
                                    <YAxis type="number" tickFormatter={this.props.tickFormatterY} domain={[this.props.dynamicYAxis.FrequencyResponse ? 'auto' : -p_fcr_ems_max || 'dataMin', this.props.dynamicYAxis.FrequencyResponse ? 'auto' : p_fcr_ems_max || 'dataMax']} />
                                    <Tooltip />
                                    <Legend verticalAlign="bottom" height={36} onClick={this.props.toggleChart} />
                                    <Line type="linear" dataKey={`activePwrReq${this.props.unit === 'kW' ? '' : 'MW'}${this.props.hidden.activePowerReq ? ' ' : ''}`} name="Requested SOC management Power by Yuso" stroke="#FF2D00" unit={this.props.unit} dot={false} />
                                    <Line type="linear" dataKey={`TargetSoC${this.props.unit === 'kW' ? '' : 'MW'}${this.props.hidden.TargetSoC ? ' ' : ''}`} name="Target SoC management by Controler" stroke="#0049FF" unit={this.props.unit} dot={dot => this.props.setDot && this.props.setDot(dot, `FCRpowerExec${this.props.unit === 'kW' ? '' : 'MW'}`, this.props.unit, 3, -10, 10, 'chart-frequency', this.props.batteryData)} />
                                </LineChart>
                            </ResponsiveContainer>
                    }
                </div>
            </div>
        )
    }
}

export default BaselinePowerSOC